/* this file added by Bearer Web Developer  */
import React, { useContext } from 'react';
import styles from './price.module.scss';
import { ReservedOrderInfoContext } from '../contexts/reservedOrderInfo';
import Name from './name';
import { useThemeMode } from '../../../../../../states/contexts/theme';


const Price: React.FC = () => {

    const reservedOrderDetails = useContext(ReservedOrderInfoContext);
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <div className={styles.price} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <h3>A$ {reservedOrderDetails?.transport_original_price}</h3>
            <div className={styles.data_number}>
                <span>BRN: </span>
                {
                    theme === 'dark' ? <img src="/help-white.svg" alt="" width={15} height={15} /> :
                        <img src="/help-grey.webp" alt="" width={18} height={18} />
                }
                <span>{reservedOrderDetails?.order_number}</span>
            </div>
            <Name />
        </div>
    )
}

export default Price;